import React from 'react';

const Header = ({ category, title, color }) => (
  <div className="flex display-center mb-1 min-w-min">
    <p className="text-lg text-blue-500 font-bold"
      style={{ color }}>
      {category}
    </p>
    <div className=" mx-auto "> {/* Update with Tailwind classes */}
      <p
        className="text-2xl  font-extrabold tracking-tight relative uppercase"
       
      >
        {title}
        {/* <span className="absolute inset-x-0 bottom-0 h-px bg-gray-300"></span> */}
      </p>
    </div>
  </div>
);

export default Header;
